module.exports = __webpack_public_path__ + "static/img/bg3.4baa3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg3.png
// module id = 449
// module chunks = 1